import React from "react";
import { Box, IconButton, SxProps, Theme } from "@mui/material";

interface Props {
  children: React.ReactNode;
  icon: React.ReactNode;
  onIconClick?: () => void;
  sx?: SxProps<Theme>;
}

const FieldWithTrailingIcon: React.FC<Props> = ({ children, icon, onIconClick, sx }) => {
  return (
    <Box display="flex" alignItems="center" gap={1} sx={sx}>
      {children}
      <IconButton onClick={onIconClick} size="small" sx={{ mt: '4px' }}>
        {icon}
      </IconButton>
    </Box>
  );
};

export default FieldWithTrailingIcon;
